import { environment } from "./environment.base";
export { environment };

environment.name = 'thejaswini';
environment.parentUrl =  'https://thejaswini.strayos.com';
environment.baseUrl = 'https://thejaswinidashboards.strayos.com';
// environment.baseUrl = 'http://localhost:4201';
environment.apiUrl = 'https://devx.strayos.com:3020';
environment.powerbiEmbedTokenUrl='https://powerbi-embed-token.azurewebsites.net/api/GetEmbedToken';
// environment.powerbiEmbedTokenUrl='http://localhost:7071/api/GetEmbedToken';